import { createAction, createReducer } from "@reduxjs/toolkit"
import { toaster } from "components/common/Toast"
import { omit, capitalize } from "lodash"
import i18n from "../../i18n"

// ACTIONS
const reseted = createAction("errors/reseted")
const recived = createAction("errors/received")

// REDUCER
const initialState = {
  fields: {},
  status: null,
  message: ""
}

const errorsReducer = createReducer(initialState, {
  [reseted.type]: () => initialState,
  [recived.type]: (state, { payload, props = {} }) => {
    console.log("[Error Reducer Called]", payload)
    const showToast = payload.showToast ?? props.showToast ?? true
    const showDetailedError = payload.showDetailedError ?? props.showDetailedError ?? false

    // Prefer user-friendly messages, but fallback to error_keys if message is missing for a field
    let fields = {}
    if (payload.data?.message && typeof payload.data.message === "object") {
      fields = { ...payload.data.message }
    }
    if (payload.data?.error_keys && typeof payload.data.error_keys === "object") {
      Object.entries(payload.data.error_keys).forEach(([key, value]) => {
        if (!fields[key]) fields[key] = value
      })
    }
    const hasFields = Object.keys(fields).length

    // If message is a string, use it as the main error message
    let mainErrorMessage = typeof payload.data?.message === "string" ? payload.data?.message : ""

    Object.assign(state, { ...omit(payload, "data"), fields })

    if (mainErrorMessage && showToast) {
      toaster.error({ title: mainErrorMessage })
    } else if (hasFields) {
      const baseError = [].concat(state.fields.base).join(", ")
      // User-friendly error for any field (including body)
      let userMessage = ""
      if (Array.isArray(fields.body)) {
        userMessage = fields.body.join(", ")
      } else if (fields.body) {
        userMessage = fields.body
      }
      // If not body, look for any other field
      if (!userMessage) {
        userMessage = Object.values(fields).flat().join(", ")
      }
      // All field errors, formatted
      const errorMessages = Object.entries(fields)
        .map(([field, messages]) => `${capitalize(field)} ${Array.isArray(messages) ? messages.join(", ") : messages}`)
        .join("; ")

      if (showToast && !baseError) {
        toaster.error({
          title: errorMessages || userMessage || i18n.t("errors.not_valid"),
          ...(showDetailedError && { text: errorMessages })
        })
      }
      if (baseError && showToast) {
        toaster.error({ title: baseError })
      }
    } else if (showToast) {
      toaster.error({
        title: payload.statusText,
        text: `${payload.method}:${payload.url}<br/>${payload.message}`
      })
    }
  }
})

export const parseErrors = (errors) =>
  Object.entries(errors)
    .map(([field, text]) => `<span class='fw-medium'>[${capitalize(field)}]</span>: ${Array(0).concat(text).join(", <br/>")}`)
    .join("<hr/>")

export default errorsReducer

export { recived as receiveErrors, reseted as resetErrors }
